import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { ApiVisa } from 'blg-akaun-ts-lib';
import { SessionActions } from '../../modules/session/session-controller/actions';
import { SessionSelectors } from '../../modules/session/session-controller/selectors';
import { SessionStates } from '../../modules/session/session-controller/states';
import { DropDownService } from '../../services/drop-down-service';
import { ReplaySubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { ListingInputModel } from '../../models/listing-input.model';
import { ListingService } from '../../services/listing-service';

@Component({
  selector: 'app-select-pos-card-terminal-drop-down',
  templateUrl: './select-pos-card-terminal-drop-down.component.html',
  styleUrls: ['./select-pos-card-terminal-drop-down.component.css']
})
export class SelectPosCardTerminalDropDownComponent implements OnInit, OnDestroy {

  @Input() cardTerminal: FormControl;
  @Input() apiVisa: ApiVisa;
  @Input() selectedGuid: string;
  @Input() label = 'Card Terminal';
  @Input() options: any;

  @Output() cardTerminalSelected = new EventEmitter<any>();

  serverSideFiltering = new FormControl();
  filteredOptions$: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  selectedRow: any;
  rowData: any = [];
  key = "cardTerminal";
  allSelected = false;
  filteredCache: any = [];

  /** flags to set the toggle all checkbox state */
  isIndeterminate = false;
  isChecked = false;

  protected _onDestroy = new Subject<void>();

  constructor(private dropDownService: DropDownService,
    private listingService: ListingService,
    private readonly store: Store<SessionStates>
  ) { }

  ngOnInit() {
    // set initial selection
    this.store.select(SessionSelectors.selectDropDownRowData).subscribe(resolved => {
      this.rowData = resolved?resolved[this.key]?resolved[this.key]:[]:[];
      if (this.rowData.length === 0) {
        this.getRowData();
      }
      else {
        this.filteredOptions$.next(this.rowData.slice());
      }
    })

    // listen for search field value changes
    this.serverSideFiltering.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filtering();
      });
  }

  ngOnChanges() {
    //console.log('ngOnChanges');
  }

  getRowData() {
    let formData = this.getInputModel();
    this.listingService.get("pos-card-terminal/backoffice-ep", formData, this.apiVisa).pipe(

    ).subscribe(resolved => {
      this.rowData = resolved.data;
      this.store.dispatch(SessionActions.selectDropDownRowData({key: this.key, rowData: this.rowData}));
      //fill the drop down
      this.filteredOptions$.next(this.rowData.slice());
    });
  }

  filtering() {
    if (!this.rowData) {
      return;
    }
    // get the search keyword
    let search = this.serverSideFiltering.value;
    if (!search) {
      this.filteredOptions$.next(this.rowData.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the cardTerminal
    this.filteredOptions$.next(
      this.rowData.filter((option) =>
        (option.code ?
          option.code.toLowerCase().indexOf(search) > -1 : null) ||
        (option.name ?
          option.name.toLowerCase().indexOf(search) > -1 : null))
    );
  }

  onSelect(guid: string) {
    if (guid) {
      this.cardTerminal.patchValue(guid);
      this.selectedRow = this.rowData.find(row => row.guid === guid);
      this.cardTerminalSelected.emit(this.selectedRow);
    }
  }

  isRequired() {
    let value = this.options['required'];
    if (value === true || value === false) {
      return value;
    }
    else if (value) {
      return value.includes(true);
    }
    return false;
  }

  isMultiple() {
    let value = this.options['multiple'];
    if (value === true || value === false) {
      return value;
    }
    else if (value) {
      return value.includes(true);
    }
    return false;
  }

  toggleSelectAll(selectAllValue: boolean) {
    this.filteredOptions$.pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(val => {
        if (selectAllValue) {
          this.cardTerminal.patchValue([...val.map(item => item.guid)]);
        } else {
          this.cardTerminal.patchValue([]);
        }
      });
  }

  setToggleAllCheckboxState() {
    if (!this.isMultiple()) return;
    let filteredLength = 0;
    if (this.cardTerminal && this.cardTerminal.value) {
      this.filteredCache.forEach(el => {
        if (this.cardTerminal.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminate = filteredLength > 0 && filteredLength < this.filteredCache.length;
      this.isChecked = filteredLength > 0 && filteredLength === this.filteredCache.length;
    }
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  getInputModel() {
    const inputModel = {} as ListingInputModel;
    inputModel.search = "";
    inputModel.searchColumns = ['code', 'name'];
    inputModel.status = ['ACTIVE'];
    inputModel.orderBy = 'code';
    inputModel.order = 'asc';
    inputModel.limit = null;
    inputModel.offset = 0;
    inputModel.calcTotalRecords = false;
    inputModel.showCreatedBy = false;
    inputModel.showUpdatedBy = false;
    inputModel.filterLogical= 'AND';

    return inputModel;
  }
}
